var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-reverse-transition',[(_vm.bottomShortcut)?_c('self-activator',{key:_vm.bottomShortcut.id,attrs:{"bottomShortcut":_vm.bottomShortcut}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }